var handle_array = ["shining-einscan-hx","calibry-mini-scanner","calibry-scanner","evixscan-3d-heavy-duty-quadro"];
 var productid_array = ["6775767695546"];
 var hide_price=1;
 var hide_ajaxaddtocart=1;
 var display_phone=1;
 var phone_no = '416-479-0009';
 var display_call_for_price = 1;
 var call_for_price_label = 'Call for Price';
 var css_style_button='background-color: #000000;color:#ffffff;';
 var enabled_captcha = 0;
 var site_key = '';
 var recaptcha_ver = 'v2';
 var thankyou_msg = 'Your Request Submitted Successfully.';
 var thankyou_header = 'Success';
 var name_label='Name';
 var email_label='Email';
 var phone_label = ' Phone Number';
 var comment_label = 'Comment';
 var submit_label ='Submit';
  var error_name_label='Please fill out this field.';
 var error_email_label='Please fill out this field.';
 var error_phone_label = 'Please fill out this field.';
 var error_comment_label = 'Please fill out this field.';
 var enable_app =1;
  var enable_outofstock = 1;
 var price_selector='.search-bar__item-price, .product-item__price-list, .product-form__info-item--quantity';
 var cart_selector='#AddToCart-product-template';
 var phone_no_label = 'Call for Price:';
 var required_field='name,email,comment';
 var contact_form_heading='Call for Price for';
 var parent_selector='.search-bar__result-products';
 var unavailable_label='Unavailable';
 var show_price='no';
 var enable_cfp_for_zero_price_prd='no';
 var enable_cfp_for_all_products='no';
 var enable_cfp_soldout_products='no';
 var hide_cfp_btn_on_collection='no';
 var hide_phone_no_on_collection='no';
 var enable_whatsapp = 0;
 var whatsapp_number = '';
 var whatsapp_message = '';
 var hide_whatsapp_button_on_collection = 0;
 var whatsapp_button_text ='';
 var whatsapp_button_background_color ='#000000';
 var whatsapp_button_text_color ='#ffffff';
 var whatsapp_css_style_button ='';
 var phoneno_css_style_button ='';